module.exports = __webpack_public_path__ + "img/comfort.16384a06.svg";